<template>
  <div class="company-content-wrapper pt-0">
    <div v-if="step === 'companies-info'">
      <companies-info type="create" />
    </div>
    <div v-if="step === 'companies-created'">
      <companies-created type="create" @saved="saved" />
    </div>
    <div v-if="step === 'companies-map'">
      <companies-map type="create" @saved="saved" />
    </div>
    <div v-if="step === 'companies-settings'">
      <companies-settings type="create" @saved="saved" />
    </div>
    <div v-if="step === 'companies-availability'">
      <companies-availability type="create" @saved="saved" />
    </div>
    <div v-if="step === 'companies-pricing'">
      <companies-pricing type="create" @saved="saved" />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import CompaniesAvailability from './CompaniesAvailability';
import CompaniesCreated from './CompaniesCreated';
import CompaniesInfo from './CompaniesInfo';
import CompaniesMap from './CompaniesMap';
import CompaniesPricing from './CompaniesPricing';
import CompaniesSettings from './CompaniesSettings';

export default {
  components: {
    CompaniesAvailability,
    CompaniesCreated,
    CompaniesInfo,
    CompaniesMap,
    CompaniesSettings,
    CompaniesPricing,
  },
  computed: {
    ...mapState({
      step: state => state.companies.step,
    }),
  },
  created() {
    this.setSavedCoverage(false);
    this.setSavedSettings(false);
  },
  destroyed() {
    this.setCompanyStep('companies-info');
  },
  methods: {
    ...mapMutations(['setCompanyStep', 'setSavedCoverage', 'setSavedSettings']),
    saved() {
      this.$store.dispatch('authRefresh');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/companies/CompaniesCreate.vue